export default "__VITE_ASSET__XODUePaU__";